import type { ReactNode } from 'react';

type Tone = 'gray' | 'green' | 'red' | 'yellow' | 'accent';

const toneClass: Record<Tone, string> = {
  gray: 'bg-raised text-muted ring-line',
  green: 'bg-positive-soft text-positive ring-positive/20',
  red: 'bg-negative-soft text-negative ring-negative/10',
  yellow: 'bg-warning-soft text-warning ring-warning/20',
  accent: 'bg-accent-soft text-accent-ink ring-accent/20',
};

export const Badge = ({ tone = 'gray', children }: { tone?: Tone; children: ReactNode }) => (
  <span
    className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset ${toneClass[tone]}`}
  >
    {children}
  </span>
);
